import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import MailSource from 'sources/inbox/MailSource';

class MailActions {
  constructor() {
    this.generateActions(
      'clearMailForFilters',
      'unselectMail',
      'selectMail',
      'selectAll',
      'unselectAll',
      ...generateAsyncActions(
        'fetchMail',
        'fetchMailItem',
        'saveMail',
        'bulkMoveFolder',
        'bulkMarkAsRead',
        'bulkSetPinned',
        'markCallAsRead'
      )
    );
  }
  fetchMail(filters, page) {
    return dispatch => {
      dispatch([filters, page]);
      return MailSource.fetchMail(filters, page).then(
        data => this.fetchMailSuccess([filters, data]),
        error => {
          this.fetchMailError(filters);
          throw error;
        }
      );
    };
  }

  /**
   * Fetch a mail item, optionally specify if you want to override the store.
   * If munging happened previously (grouping), specify overwrite=false
   * to preserve.
   * @param id - file id
   * @param overwrite - should we overwrite the store?
   */
  fetchMailItem(id, overwrite = true) {
    return dispatch => {
      dispatch([id, overwrite]);
      return MailSource.fetchMailItem(id).then(
        rslt => this.fetchMailItemSuccess([rslt, overwrite]),
        error => {
          this.fetchMailItemError([id, error]);
          throw error;
        }
      );
    };
  }
  // An attempt to create a layer over the the api that
  // is closer to what I would consider ideal
  // (a singular PUT on the mail item that would let you update it)
  // vs multiple endpoints to update each property.
  // It's a bit weird though because you have to pass the previous item
  // state for it to figure out what changed.
  saveMail(inboxItem, prevItemState) {
    return dispatch => {
      dispatch(inboxItem);
      return new Promise(async resolve => {
        if (inboxItem.pinned !== prevItemState.pinned) {
          await MailSource.togglePinned(inboxItem);
        }

        if (inboxItem.viewedDate && !prevItemState.viewedDate) {
          await MailSource.markAsViewed(inboxItem);
        }

        if (inboxItem.folderId !== prevItemState.folderId) {
          await MailSource.changeFolder(inboxItem, prevItemState.folderId, inboxItem.folderId);
        }
        resolve(inboxItem);
      }).then(() => this.saveMailSuccess(inboxItem));
    };
  }

  bulkMoveFolder(params) {
    return dispatch => {
      dispatch(params);
      return MailSource.bulkMoveFolder(params).then(
        () => this.bulkMoveFolderSuccess(params),
        error => {
          this.bulkMoveFolderError([params, error]);
          throw error;
        }
      );
    };
  }

  bulkMarkAsRead(params) {
    return dispatch => {
      dispatch(params);
      return MailSource.bulkMarkAsRead(params).then(
        () => this.bulkMarkAsReadSuccess(params),
        error => {
          this.bulkMarkAsReadError([params, error]);
          throw error;
        }
      );
    };
  }

  bulkSetPinned(params) {
    return dispatch => {
      dispatch(params);
      return MailSource.bulkSetPinned(params).then(
        () => this.bulkSetPinnedSuccess(params),
        error => {
          this.bulkSetPinnedError([params, error]);
          throw error;
        }
      );
    };
  }

  markCallAsRead(callId) {
    return dispatch => {
      dispatch();
      return MailSource.markCallAsRead(callId).then(
        this.markCallAsReadSuccess,
        this.markCallAsReadError
      );
    };
  }
}

export default alt.createActions(MailActions);
